import React from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EfModal from '@/components/UI/Modal';
import Button from '@/components/UI/Button';

interface PointsModalProps {
    open?: boolean;
    onCancel?: () => void;
    setShowPage?: (page: string) => void;
}

const PointsModal: React.FC<PointsModalProps> = ({ open, onCancel, setShowPage }) => {
    const { useLang } = useGlobal();
    const { t } = useLang('ecocredits');
    return (
        <EfModal centered className={css.efmodal} visible={open} zIndex={1200} onCancel={onCancel}>
            <div className="content">
                <h5 className="title">{t('prize_points_title')}</h5>
                <p className="sub-title">
                    {t.rich('prize_points_desc', {
                        code: (children: string) => (
                            <i
                                className="btn"
                                onClick={() => {
                                    setShowPage?.('history_modal');
                                    onCancel?.();
                                }}
                            >
                                {children}
                            </i>
                        ),
                    })}
                </p>
                <Button onClick={onCancel} className="m-btn">
                    {t('confirm_btn_text')}
                </Button>
            </div>
        </EfModal>
    );
};

export default PointsModal;
